const loaded = new Set<string>();
const preloadedLinks = new Set<string>();

function injectPreloadLink(url: string, priority: 'high' | 'low' = 'low') {
  if (preloadedLinks.has(url) || typeof document === 'undefined') return;
  preloadedLinks.add(url);
  const link = document.createElement('link');
  link.rel = 'preload';
  link.as = 'image';
  link.href = url;
  if (priority === 'high') {
    link.setAttribute('fetchpriority', 'high');
  }
  document.head.appendChild(link);
}

function preloadOne(url: string, priority: 'high' | 'low' = 'low'): Promise<void> {
  if (loaded.has(url)) return Promise.resolve();
  injectPreloadLink(url, priority);
  return new Promise((resolve) => {
    const img = new Image();
    if (priority === 'high') {
      img.fetchPriority = 'high';
    }
    img.onload = () => {
      loaded.add(url);
      resolve();
    };
    img.onerror = () => resolve();
    img.src = url;
  });
}

/** Preload images; first URL gets high priority (level 0 / hero). */
export function preloadImages(urls: string[]): Promise<void> {
  const unique = [...new Set(urls.filter(Boolean))];
  if (!unique.length) return Promise.resolve();
  const [first, ...rest] = unique;
  return preloadOne(first, 'high')
    .then(() => Promise.all(rest.map((url) => preloadOne(url, 'low'))))
    .then(() => undefined);
}
